import { useReducer } from "react";
import { formDefaultState } from "../../Reducers/FormDefaultState";
import FormReducer from "../../Reducers/FormReducer";

import SignUpFormGroup from "./SignUpFormGroup";

const SignUpForm = () => {
  //reducer
  const [formState, dispatchForm] = useReducer(
    FormReducer,
    formDefaultState
  );

  return (
    <SignUpFormGroup
      //onSubmit={submitFormHandler}
      onDispatchForm={dispatchForm}
      formState={formState}
    />
  );
};

export default SignUpForm;
